import { render } from "./loginImg.vue?vue&type=template&id=f0f5c344&scoped=true"
import script from "./loginImg.vue?vue&type=script&lang=js"
export * from "./loginImg.vue?vue&type=script&lang=js"

import "./loginImg.vue?vue&type=style&index=0&id=f0f5c344&lang=scss&scoped=true"

import exportComponent from "E:\\giteeWorkShowma\\hardware-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0f5c344"]])

export default __exports__